import { observer } from "mobx-react";
import Tabs from "newApp/kit/components/Tabs";
import {
  URL_SITE_TECHSUPPORT_ANSWERED,
  URL_SITE_TECHSUPPORT_NEW,
} from "newApp/routing/urls";
import React from "react";
import { useHistory, useLocation } from "react-router";

const TechSupportNavigator: React.FC = () => {
  const { push } = useHistory();
  const { pathname } = useLocation();

  const tabs = [
    {
      title: "Новые",
      onClick: () => push(URL_SITE_TECHSUPPORT_NEW),
      isActive: pathname === URL_SITE_TECHSUPPORT_NEW,
    },
    {
      title: "Обработанные",
      onClick: () => push(URL_SITE_TECHSUPPORT_ANSWERED),
      isActive: pathname === URL_SITE_TECHSUPPORT_ANSWERED,
    },
  ];

  return <Tabs tabs={tabs} />;
};

export default observer(TechSupportNavigator);
